module.exports = __webpack_public_path__ + "d766cfd896f7334c969217c05ce8c7d6.MP3";